export default "__VITE_ASSET__DHmJBndZ__"